import { DatePicker } from 'bricks-ui/packages/bricks-ui';

export default DatePicker;
